import { useState, useEffect } from 'react';

export type Breakpoint = 'mobile' | 'sm' | 'lg';

/**
 * Hook responsive qui retourne le breakpoint actuel :
 * - 'mobile' : < 640px
 * - 'sm'     : 640px – 1023px
 * - 'lg'     : >= 1024px
 */
export function useBreakpoint(): Breakpoint {
  const [breakpoint, setBreakpoint] = useState<Breakpoint>(() => {
    if (typeof window === 'undefined') return 'lg';
    if (window.innerWidth >= 1024) return 'lg';
    if (window.innerWidth >= 640) return 'sm';
    return 'mobile';
  });

  useEffect(() => {
    const mqLg = window.matchMedia('(min-width: 1024px)');
    const mqSm = window.matchMedia('(min-width: 640px)');

    const update = () => {
      if (mqLg.matches) setBreakpoint('lg');
      else if (mqSm.matches) setBreakpoint('sm');
      else setBreakpoint('mobile');
    };

    update();
    mqLg.addEventListener('change', update);
    mqSm.addEventListener('change', update);
    return () => {
      mqLg.removeEventListener('change', update);
      mqSm.removeEventListener('change', update);
    };
  }, []);

  return breakpoint;
}
